/**
 * Libellé court pour la carte accueil — priorité à la règle CDC (valise VALED).
 */
export function getNeuroCardLabel(neuroSummary) {
  if (!neuroSummary) return null;

  if (neuroSummary.profile_label) {
    return shortenProfileLabel(neuroSummary.profile_label);
  }

  if (neuroSummary.matched_rule?.name) {
    return shortenProfileLabel(neuroSummary.matched_rule.name);
  }

  if (neuroSummary.dominant) {
    const { label, score, is_balanced: isBalanced, display_score: displayScore } = neuroSummary.dominant;
    if (isBalanced || score < 3) return 'Profil équilibré';
    if (displayScore) return `${label} ${displayScore}`;
    return `${label} ${score}/10`;
  }

  const scores = neuroSummary.scores || neuroSummary;
  const axes = [
    { score: scores.tdah ?? scores.score_tdah ?? 0, label: 'Dynamisme' },
    { score: scores.tsa ?? scores.score_tsa ?? 0, label: 'Sensoriel' },
    { score: scores.dys ?? scores.score_dys ?? 0, label: 'Apprentissage' },
  ];
  const top = [...axes].sort((a, b) => b.score - a.score)[0];
  if (top.score < 3) return 'Profil équilibré';
  return `${top.label} ${top.score}/10`;
}

function shortenProfileLabel(label) {
  if (!label) return null;
  if (label.length <= 28) return label;
  if (label.includes('Sérénité')) return 'Valise Sérénité';
  if (label.includes('Lecture')) return 'Valise Lecture';
  if (label.includes('complète') || label.includes('Complète')) return 'Valise complète';
  return `${label.slice(0, 25)}…`;
}

export function parseProfilingPaths(kid) {
  if (!kid?.profiling_paths_completed) return { pedagogical: false, neuro: false };
  if (typeof kid.profiling_paths_completed === 'string') {
    try { return JSON.parse(kid.profiling_paths_completed); } catch { return { pedagogical: false, neuro: false }; }
  }
  return kid.profiling_paths_completed;
}
